import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import './creaInstancia.css';
import TablaAlumnosCurso from './TablaAlumnoCurso';
import obtieneDatosUsuario from '../obtieneDatosCookiesUsuario';
import ListadoMaterias from './ListadoMaterias';

const SelectorCursosActivos = (props) => {
  const Usuario=obtieneDatosUsuario()
  const { register, handleSubmit, reset } = useForm();
  const [cursosDisponibles, setCursosDisponibles] = useState([]);
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [cantDivisiones, setCantDivisiones] = useState(0);
  const [divisionSeleccionada, setDivisionSeleccionada] = useState(null);
  const [datosDivision, setDatosDivision] = useState(null);
  const [escuelaSeleccionada, setEscuelaSeleccionada] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);

  // 🎨 Color por escuela
  const getColorPorEscuela = (escuela, usarColores) => {
    if (!usarColores) return 'black';

    switch (escuela) {
      case "Escuela de Policia":
        return '#007bff';
      case "Escuela de Especialidades":
        return '#28a745';
      case "Escuela Superior":
        return '#6f42c1';
      case "Escuela de Investigaciones":
        return '#fd7e14';
      case "Educacion a Distancia":
        return '#dc3545';
        case "Extracurricular":
          return '#36f233';
        case "Extension Comunitaria":
          return '#f233d2';
         
          default:
            return '#6c757d';
          }
        };
        
        // 🏫 Detectar escuelas según usuario
        useEffect(() => {
    const Usuario = obtieneDatosUsuario();
    const textoFuncion = Usuario.funcion || "";

    const palabrasClave = [
      "Escuela de Policia",
      "Escuela de Especialidades",
      "Escuela Superior",
      "Escuela de Investigaciones",
      "Educacion a Distancia",
      "Extracurricular",
      "Extension Comunitaria"
    ];

    const escuelasEncontradas = palabrasClave.filter(clave =>
      textoFuncion.includes(clave)
    );
// console.log(escuelasEncontradas)
    if (Usuario.destino === 1 || Usuario.destino === 7) {
      setEscuelaSeleccionada("Todo");
    } else if (escuelasEncontradas.length > 0) {
      setEscuelaSeleccionada(escuelasEncontradas.join(','));
    } else {
      setEscuelaSeleccionada("Escuela de Policia");
    }
  }, []);

  // 📥 Cargar cursos por escuela
  useEffect(() => {
    if (!escuelaSeleccionada) return;

   const pere= axios.post(
      'https://wwwa.isepsantafe.net.ar/expedientes/cursos/devuelveCursosPorEscuela/' + escuelaSeleccionada,
      { estadoCurso: "Activo" }
      
    )
      .then(response => {
//         console.log(response)
        const cursosOrdenados = response.data.Cursos.sort((a, b) =>
          a.nombreCurso.localeCompare(b.nombreCurso)
        );
        setCursosDisponibles(cursosOrdenados);
      })
      .catch(error => {
        console.error('Error al cargar cursos:', error);
      });
  }, [escuelaSeleccionada]);

  // 🎯 Selección de curso
  const handleSelectChange = (event) => {
    const cursoId = parseInt(event.target.value);
    const cursoSeleccionado = cursosDisponibles.find(curso => curso.id === cursoId);

    if (cursoSeleccionado) {
      setSelectedCurso(cursoSeleccionado);
      setCantDivisiones(cursoSeleccionado.cantDivisiones || 0);
      setDivisionSeleccionada(null);
      setDatosDivision(null);
    }
  };

  // 🧩 Selección de división
  const handleDivisionClick = async (divisionNumero) => {
    setDivisionSeleccionada(divisionNumero);

    try {
      const response = await axios.post(
        'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAlumnosCursos',
        {
          idCurso: selectedCurso.id,
          division: divisionNumero
        }
      );

      setDatosDivision(response.data);
      setModalAbierto(true);
    } catch (error) {
      console.error('Error al consultar división:', error);
    }
  };

  // 🎨 Detectar si hay más de una escuela
  const escuelasUnicas = [...new Set(cursosDisponibles.map(c => c.escuela))];
  const usarColores = escuelasUnicas.length > 1;

  // 📚 Agrupar cursos por escuela (para optgroup)
 // 📚 Agrupar cursos por ESCUELA y luego por SEDE
const cursosPorEscuelaYSede = cursosDisponibles.reduce((acc, curso) => {
  const escuela = curso.escuela || "Sin escuela";
  const sede = curso.sede || "Sin sede";

  if (!acc[escuela]) acc[escuela] = {};
  if (!acc[escuela][sede]) acc[escuela][sede] = [];

  acc[escuela][sede].push(curso);
  return acc;
}, {});


  // ⌨️ Cerrar modal con ESC
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setModalAbierto(false);
      }
    };

    if (modalAbierto) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalAbierto]);

  return (
    <div>
      <form className="form-container">
        <div className="form-group">
          <label htmlFor="select">Seleccione un curso:</label>
<select id="select" onChange={handleSelectChange}>
  <option value="">-- Selecciona un curso --</option>

  {Object.entries(cursosPorEscuelaYSede)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([escuela, sedes]) => {
      
      // 🔹 Filtrar sedes según Usuario.sedeID
      const sedesFiltradas = Object.entries(sedes).filter(([sede]) => {
        if (Usuario.sedeID == 1) return true;
        if (Usuario.sedeID == 2) return sede === "Rosario";
        if (Usuario.sedeID == 3) return sede === "Recreo";
        if (Usuario.sedeID == 4) return sede === "Reconquista";
        return false;
      });

      // Si no hay sedes visibles, no renderizar la escuela
      if (sedesFiltradas.length === 0) return null;

      return (
        <optgroup key={escuela} label={escuela}>
          {sedesFiltradas
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([sede, cursos]) => (
              <React.Fragment key={sede}>
                
                <option disabled>
                  ── {sede}
                </option>

                {cursos
                  .sort((a, b) =>
                    a.nombreCurso.localeCompare(b.nombreCurso)
                  )
                  .map((curso) => (
                    <option
                      key={curso.id}
                      value={curso.id}
                      style={{
                        color: getColorPorEscuela(
                          curso.escuela,
                          usarColores
                        ),
                      }}
                    >
                      {curso.nombreCurso}
                    </option>
                  ))}
              </React.Fragment>
            ))}
        </optgroup>
      );
    })}
</select>
        </div>
      </form>

      {cantDivisiones > 0 && (
        <div className="divisiones-buttons">
          <h4>Seleccione una división:</h4>
          {[...Array(cantDivisiones)].map((_, index) => (
            <button
              key={index}
              onClick={() => handleDivisionClick(index + 1)}
              className="btn btn-primary"
            >
              División {index + 1}
            </button>
          ))}
        </div>
      )}

      {modalAbierto && datosDivision && selectedCurso && divisionSeleccionada && (
        <div
          className="modal-overlay"
          onClick={() => setModalAbierto(false)}
        >
          <div
            className="modal-contenido"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h4>
                {selectedCurso.nombreCurso} – División {divisionSeleccionada}
              </h4>
              <button
                className="btn btn-danger"
                onClick={() => setModalAbierto(false)}
              >
                ✕ Cerrar
              </button>
            </div>

            <div className="modal-body">
              <TablaAlumnosCurso
                idCurso={selectedCurso.id}
                division={divisionSeleccionada}
                nombreCurso={selectedCurso.nombreCurso}
                escuelaDePolicia={selectedCurso.escuela === "Escuela de Policia"}
                curso={selectedCurso}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectorCursosActivos;
